/**
 * Sistem Ayarları › SMS Gönderen Adları (backlog #637, backend #635 / #636): satıcıdaki onaylı / bekleyen / reddedilmiş gönderen adları ve yeni ad başvurusu.
 * Liste satıcıdan okunur ("Yenile" satıcıya gidip durumları günceller); başvuru onay gerektirir, sonuç günler sürebilir. Ad kuralı hesap formundakiyle aynı:
 * 3-11 karakter, Türkçe harf ve özel karakter yok. Başvuru SYSTEM_SETTINGS_MANAGE ister.
 */
import React, { useEffect, useState } from 'react';
import { Alert, Badge, Button, Card, CardBody, Form, FormFeedback, Input, Label, Spinner, Table } from 'reactstrap';
import { useTranslation } from 'react-i18next';
import SmsSayfa from './SmsSayfa';
import { applySender, listSenders, refreshSenders } from '../../../../services/smsAyarService';
import { gonderenGecerli } from './SmsHesaplariPage';

const RENK = { APPROVED: 'success', PENDING: 'warning', REJECTED: 'danger' };

const SmsGonderenAdlariPage = () => {
  const { t } = useTranslation('sms');
  const [adlar, setAdlar] = useState([]);
  const [yukleniyor, setYukleniyor] = useState(true);
  const [yenileniyor, setYenileniyor] = useState(false);
  const [hata, setHata] = useState(null);
  const [mesaj, setMesaj] = useState(null);
  const [yeniAd, setYeniAd] = useState('');
  const [basvuruyor, setBasvuruyor] = useState(false);

  useEffect(() => {
    let iptal = false;
    async function calistir() {
      try {
        const liste = await listSenders();
        if (!iptal) setAdlar(liste);
      } catch (e) {
        if (!iptal) setHata(e.message);
      } finally {
        if (!iptal) setYukleniyor(false);
      }
    }
    calistir();
    return () => { iptal = true; };
  }, []);

  async function yenile() {
    setYenileniyor(true);
    setHata(null);
    try {
      setAdlar(await refreshSenders());
    } catch (e) {
      setHata(e.message);
    } finally {
      setYenileniyor(false);
    }
  }

  async function basvur(e) {
    e.preventDefault();
    if (!gonderenGecerli(yeniAd)) return;
    setBasvuruyor(true);
    setHata(null);
    setMesaj(null);
    try {
      await applySender(yeniAd);
      setYeniAd('');
      setMesaj(t('gonderenAdlari.basvuruAlindi'));
      setAdlar(await listSenders());
    } catch (err) {
      setHata(err.message);
    } finally {
      setBasvuruyor(false);
    }
  }

  const hatali = yeniAd.trim() !== '' && !gonderenGecerli(yeniAd);

  return (
    <SmsSayfa aktif="gonderenAdlari">
      {mesaj && <Alert color="success" fade={false} toggle={() => setMesaj(null)}>{mesaj}</Alert>}
      {hata && <Alert color="danger" fade={false} data-testid="sms-gonderen-hata">{hata}</Alert>}
      <Card>
        <CardBody>
          <div className="d-flex justify-content-between align-items-center mb-3">
            <p className="text-muted mb-0">{t('gonderenAdlari.aciklama')}</p>
            <Button color="light" id="sms-gonderen-yenile" disabled={yenileniyor} onClick={yenile}>
              {yenileniyor ? <Spinner size="sm" /> : <><i className="bx bx-refresh me-1" />{t('gonderenAdlari.yenile')}</>}
            </Button>
          </div>
          {yukleniyor ? <div className="text-center py-4"><Spinner /></div> : (
            <Table hover className="align-middle mb-4" data-testid="sms-gonderen-tablosu">
              <thead><tr><th>{t('gonderenAdlari.ad')}</th><th>{t('gonderenAdlari.durum')}</th></tr></thead>
              <tbody>
                {adlar.length === 0 && <tr><td colSpan={2} className="text-center text-muted py-4">{t('gonderenAdlari.bos')}</td></tr>}
                {adlar.map((a) => (
                  <tr key={a.name}>
                    <td className="fw-semibold">{a.name}</td>
                    <td><Badge color={RENK[a.status] || 'secondary'}>{t(`gonderenAdlari.durumlar.${a.status}`, { defaultValue: a.status })}</Badge></td>
                  </tr>
                ))}
              </tbody>
            </Table>
          )}
          <Form onSubmit={basvur} data-testid="sms-gonderen-formu" className="border-top pt-3">
            <h6>{t('gonderenAdlari.yeniBasvuru')}</h6>
            <div className="d-flex gap-2 align-items-start flex-wrap">
              <div style={{ minWidth: 240 }}>
                <Label htmlFor="sms-yeni-gonderen" className="visually-hidden">{t('gonderenAdlari.ad')}</Label>
                <Input id="sms-yeni-gonderen" value={yeniAd} onChange={(e) => setYeniAd(e.target.value)} maxLength={32} invalid={hatali} placeholder={t('gonderenAdlari.ornek')} />
                <FormFeedback>{t('hesaplar.gonderenKurali')}</FormFeedback>
              </div>
              <Button color="primary" type="submit" id="sms-gonderen-basvur" disabled={basvuruyor || !gonderenGecerli(yeniAd)}>
                {basvuruyor ? <Spinner size="sm" /> : t('gonderenAdlari.basvur')}
              </Button>
            </div>
            <div className="form-text">{t('gonderenAdlari.basvuruNotu')}</div>
          </Form>
        </CardBody>
      </Card>
    </SmsSayfa>
  );
};

export default SmsGonderenAdlariPage;
